<script>
    import TextInput from '../../TextInput.svelte';

    export let data = '';
    export let onChange = () => {};
    export let row = null;
    export let key = '';
    export let multiline = false;
    export let schema = {}
    export let id = '';
    function handleColumnChange(event) {
        onChange(event, row);
    }
</script>

<TextInput
        {id}
        {key}
        bind:value={data}
        on:change={handleColumnChange}
        bind:isValid={row.fieldValidations[key].isValid}
        bind:errors={row.fieldValidations[key].errors}
        multiline={multiline}
        object={row}
        {schema}
        />